import type { CarouselItem } from "@/lib/api";

export default function PublishJobProgress({
  item,
  running,
  error,
}: {
  item?: CarouselItem | null;
  running: boolean;
  error?: string;
}) {
  const progress = item?.publish_progress;
  const percent = Number(
    progress?.percent || (running ? 6 : item?.status === "published" ? 100 : 0),
  );
  return (
    <div>
      <div className="mb-1 flex items-center justify-between text-sm">
        <span>{progress?.detail || (running ? "kolejne kroki IG, potem FB" : "")}</span>
        <span className="font-medium tabular-nums">{percent}%</span>
      </div>
      <div className="mb-3 h-2 overflow-hidden rounded-full bg-muted">
        <div className="h-full bg-brand transition-all" style={{ width: `${percent}%` }} />
      </div>
      <ol className="space-y-2 text-xs">
        {(progress?.steps || []).map((step) => (
          <li key={step.id} className="rounded-md border border-border px-2 py-1.5">
            {step.state === "done"
              ? "OK"
              : step.state === "skipped"
                ? "pominięto"
                : step.state === "active"
                  ? "teraz"
                  : step.state === "error"
                    ? "błąd"
                    : "czeka"}
            {" · "}
            {step.label}
            {step.state === "error" && step.detail ? (
              <span className="mt-0.5 block text-[11px] text-destructive">{step.detail}</span>
            ) : null}
          </li>
        ))}
      </ol>
      {error ? <p className="mt-2 text-sm text-destructive">{error}</p> : null}
      {item?.publish_error ? <p className="mt-2 text-sm text-destructive">{item.publish_error}</p> : null}
    </div>
  );
}
